import YAML from "yaml";

const defaultCfg = {
  core: {
    workers_max_count: 5,
    backpressure_decay: 21,
    queue_max_size: 10,
    data_dir: "data/",
  },
  monitor: {
    enabled: true,
    heart_beat_timeout: 10,
    personal_host: "wsn.tele.heado.ru",
    personal_port: 443,
    ssl: true,
    status_report_period: 600,
  },
  service: {
    log_rotate_size: "50 MB",
    log_rotate: "DAILY",
    log_store_days: 7,
    log_level: "DEBUG",
    api_url: "https://api.heado.ru/m",
    update_enable: true,
    update_check_interval: 60,
    update_appcast_url: "https://update.heado.ru/midservice/appcast.xml",
    api_mode: "HEADO_API",
  },
  modules: [],
};

export const configTemplateBuilder = (): string => {
  const doc = new YAML.Document();
  doc.contents = defaultCfg;
  return doc.toString();
};
